<!-- HeroBanner.vue -->
<template>
  <v-container fluid class="pa-0 hero-wrap">
    <div class="hero-slab">
      <v-container class="text-center py-16 py-md-24">
        <h1 class="hero-title">
          <span class="un">un</span><span>Booked Adventures</span>
        </h1>
        <h1 class="hero-title mt-2">
          <span class="un">un</span><span>Believable Savings</span>
        </h1>

        <p class="hero-sub mt-6">
          Discover the best deals on cruises, hotels, and resorts all in one place.
        </p>
      </v-container>

      <div class="d-flex justify-center">
        <SearchBar />
      </div>
    </div>
  </v-container>
</template>

<script>
import SearchBar from './SearchBar.vue';

export default {
  name: 'HeroBanner',
  components: {
    SearchBar
  },
  data() {
    return {}
  },
  methods: {
    handleSearch() {
      console.log('Search clicked')
    }
  }
};

</script>

<style scoped>
.hero-wrap {
  padding-block: 24px;
}

/* The blue gradient card/slab */
.hero-slab {
  margin: 0 auto;
  max-width: 1440px;
  height: 550px;
  color: white;
  /* Smooth diagonal blue gradient like the image */
  background: var(--gradient-blue);
}

/* Headline */
.hero-title {
  margin: 0;
  font-weight: 800;
  line-height: 1.1;
  letter-spacing: 0.2px;
  /* Responsive sizes to mirror the large hero text */
  font-size: clamp(28px, 5vw, 56px);
}

/* “un” accent */
.un {
  color: var(--color-secondary);
  /* teal accent from your design */
  margin-right: 4px;
}

/* Subtitle */
.hero-sub {
  opacity: 0.95;
  font-weight: 600;
  font-size: clamp(14px, 1.6vw, 20px);
}

/* Extra spacing utilities to complement Vuetify’s */
.py-16 {
  padding-block: 64px;
}

.py-24 {
  padding-block: 96px;
}

/* md breakpoint alignment with Vuetify defaults */
@media (min-width: 960px) {
  .py-md-24 {
    padding-block: 96px;
  }
}
</style>
